import {
  validateFieldForRequired
} from 'libs/validator';

export const ACTIVATION_CODE_INFO_KEYS = {
  ACTIVATION_CODE: 'activation_code'
};

export const ERROR_INFO_KEYS = {
  ACTIVATION_CODE_FORM: 'activationCodeForm'
};

export const ACTIVATION_CODE_FORM_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.ACTIVATION_CODE_FORM,
  errorFields: [
    ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE
  ]
};

export function checkErrors(errorFields = [], activationCodeInfo = {}) {
  const errors = {};

  if (errorFields.indexOf(ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE) !== -1) {
    const activationCodeError =
      validateFieldForRequired(activationCodeInfo[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE]);
    if (activationCodeError) {
      errors[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE] = activationCodeError;
    }
  }

  return errors;
}

export default {
  ACTIVATION_CODE_INFO_KEYS
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/ActivationCodeDetails/config.js